'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OLXPAYBADGE_COLORS = undefined;
var _values = require('babel-runtime/core-js/object/values');
var _values2 = _interopRequireDefault(_values);
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _react = require('react');
var React = _interopRequireWildcard(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var OLXPAYBADGE_COLORS = exports.OLXPAYBADGE_COLORS = {
  colorful: 'colorful',
  white: 'white',
  colorfulWhite: 'colorful-white'
};
var ReducedOlxPayBadge = function ReducedOlxPayBadge(_ref) {
  var colors = _ref.colors,
    otherProps = (0, _objectWithoutProperties3.default)(_ref, ['colors']);
  return React.createElement('svg', (0, _extends3.default)({
    style: {
      display: 'block'
    },
    viewBox: '0 0 56 14',
    fill: 'none'
  }, otherProps, {
    'data-testid': 'OlxPayBadgereduced'
  }), React.createElement('g', null, React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M5.186 11.57c-1.547 0-2.638-1.261-2.638-3.152 0-1.89 1.091-3.151 2.638-3.151s2.639 1.26 2.639 3.151c0 1.89-1.047 3.151-2.639 3.151zm0 2.385c2.911 0 5.186-2.34 5.186-5.537 0-3.151-2.184-5.492-5.186-5.492C2.32 2.926 0 5.267 0 8.463c0 3.151 2.184 5.492 5.186 5.492z',
    fill: colors.o
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M12.556 9.723h4.958c.364 0 .546-.18.546-.54v-1.53c0-.36-.182-.54-.546-.54h-3.32V.54c0-.36-.228-.54-.546-.54H12.01c-.364 0-.546.18-.546.54v8.148c0 .675.364 1.035 1.092 1.035z',
    fill: colors.l
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M19.288 13.774l3.003-3.42 2.911 3.42c.273.316.592.316.865.046l1.182-1.036c.273-.27.319-.585.046-.855l-3.23-3.556 2.912-3.242c.272-.27.227-.585-.046-.855l-1.092-.99c-.273-.27-.591-.27-.864.045L22.29 6.437l-2.73-3.061c-.273-.27-.591-.315-.864-.045l-1.137.99c-.273.27-.319.54-.046.855l3.003 3.242-3.276 3.6c-.273.316-.227.586.046.856l1.137.99c.273.226.637.226.864-.09z',
    fill: colors.x
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M32.754 13.054l1.592-8.868h1.501l-.045.405c.455-.36 1.046-.54 1.638-.54 1.455 0 2.684 1.125 2.684 2.791 0 1.125-.592 2.34-1.638 2.926-.455.27-1.001.45-1.638.45s-1.274-.225-1.82-.585l-.636 3.421h-1.638zm2.502-4.952c.364.36.91.586 1.456.586.955 0 1.728-.766 1.728-1.801 0-.81-.546-1.395-1.41-1.395-.546 0-1.046.225-1.456.675l-.318 1.935zM47.903 4.186l-1.047 5.897h-1.501l.046-.405c-.455.36-1.047.54-1.638.54-1.456 0-2.684-1.125-2.684-2.79 0-1.126.591-2.342 1.638-2.927.454-.27 1-.45 1.637-.45.683 0 1.32.225 1.956.675l.091-.54h1.502zM45.9 6.122a2.116 2.116 0 00-1.456-.585c-.955 0-1.728.765-1.728 1.8 0 .81.545 1.396 1.41 1.396.546 0 1.046-.225 1.455-.676l.319-1.935zM56 4.186l-5.777 8.868h-1.866l2.32-3.601-1.774-5.312h1.684l1.182 3.646 2.32-3.646H56v.045z',
    fill: colors.pay
  })));
};
ReducedOlxPayBadge.propTypes = {
  colors: _propTypes2.default.shape({
    o: _propTypes2.default.string.isRequired,
    l: _propTypes2.default.string.isRequired,
    x: _propTypes2.default.string.isRequired,
    pay: _propTypes2.default.string.isRequired
  })
};
var DefaultOlxPayBadge = function DefaultOlxPayBadge(_ref2) {
  var colors = _ref2.colors,
    otherProps = (0, _objectWithoutProperties3.default)(_ref2, ['colors']);
  return React.createElement('svg', (0, _extends3.default)({
    style: {
      display: 'block'
    },
    viewBox: '0 0 68 20',
    fill: 'none'
  }, otherProps, {
    'data-testid': 'OlxPayBadge'
  }), React.createElement('g', null, React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M8.342 19.892c4.09 0 7.343-3.354 7.343-7.876 0-4.471-3.075-7.85-7.343-7.85C4.252 4.166 1 7.52 1 12.042c0 4.547 3.074 7.85 7.342 7.85zm0-3.379c-2.21 0-3.734-1.804-3.734-4.471 0-2.693 1.524-4.497 3.734-4.497s3.735 1.804 3.735 4.471c0 2.693-1.524 4.497-3.735 4.497z',
    fill: colors.o
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M18.709 13.897h7.012c.483 0 .762-.28.762-.762v-2.21c0-.483-.28-.763-.762-.763h-4.7v-9.4c0-.483-.28-.762-.762-.762h-2.312c-.483 0-.762.28-.762.762v11.61c0 .992.533 1.525 1.524 1.525z',
    fill: colors.l
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M28.233 19.666l4.218-4.853 4.09 4.853c.356.432.813.432 1.22.076l1.65-1.448c.407-.356.458-.813.077-1.22l-4.547-5.08 4.14-4.65c.356-.406.33-.838-.076-1.22l-1.55-1.397c-.406-.38-.863-.355-1.219.077l-3.785 4.395-3.862-4.395c-.355-.407-.813-.458-1.22-.077l-1.6 1.423c-.406.381-.432.788-.05 1.22l4.217 4.649-4.599 5.106c-.38.432-.33.864.076 1.22l1.6 1.397c.407.356.865.33 1.22-.076z',
    fill: colors.x
  }), React.createElement('path', {
    // eslint-disable-next-line max-len
    d: 'M46.218 11.747c.362.375.911.587 1.436.587.936 0 1.735-.761 1.735-1.798 0-.812-.524-1.386-1.386-1.386-.536 0-1.049.237-1.448.662l-.337 1.935zm-2.51 4.97L45.28 7.79h1.486l-.062.4c.45-.35 1.024-.525 1.648-.525 1.436 0 2.66 1.124 2.66 2.797 0 1.136-.6 2.335-1.611 2.935a3.295 3.295 0 01-1.636.45c-.65 0-1.249-.226-1.823-.6l-.6 3.471h-1.635zM56.818 9.762c-.362-.375-.911-.587-1.436-.587-.936 0-1.735.762-1.735 1.798 0 .812.524 1.386 1.386 1.386.537 0 1.049-.237 1.448-.662l.337-1.935zm1.986-1.973l-1.049 5.931h-1.486l.062-.4c-.45.35-1.024.525-1.648.525-1.436 0-2.66-1.124-2.66-2.797 0-1.136.6-2.335 1.611-2.934a3.29 3.29 0 011.636-.45c.662 0 1.311.225 1.935.687l.1-.562h1.499zM66.82 7.789l-5.72 8.928h-1.835l2.31-3.596-1.748-5.332h1.66l1.175 3.671 2.322-3.671h1.836z',
    fill: colors.o
  })));
};
DefaultOlxPayBadge.propTypes = {
  colors: _propTypes2.default.shape({
    o: _propTypes2.default.string.isRequired,
    l: _propTypes2.default.string.isRequired,
    x: _propTypes2.default.string.isRequired
  })
};
var getColors = function getColors(color, theme) {
  var colors = {
    o: theme.colors.white,
    l: theme.colors.white,
    x: theme.colors.white,
    pay: theme.colors.white
  };
  switch (color) {
    case OLXPAYBADGE_COLORS.colorful:
      {
        colors.o = theme.colors.secondary;
        colors.l = theme.colors.green;
        colors.x = theme.colors.primary;
        colors.pay = theme.colors.secondary;
        break;
      }
    case OLXPAYBADGE_COLORS.colorfulWhite:
      {
        colors.l = theme.colors.green;
        colors.x = theme.colors.primary;
        break;
      }
    default:
      {
        break;
      }
  }
  return colors;
};
function OlxPayBadge(_ref3) {
  var color = _ref3.color,
    reduced = _ref3.reduced,
    theme = _ref3.theme,
    otherProps = (0, _objectWithoutProperties3.default)(_ref3, ['color', 'reduced', 'theme']);
  var colors = getColors(color, theme);
  if (reduced) {
    return React.createElement(ReducedOlxPayBadge, (0, _extends3.default)({
      colors: colors
    }, otherProps));
  }
  return React.createElement(DefaultOlxPayBadge, (0, _extends3.default)({
    colors: colors
  }, otherProps));
}
OlxPayBadge.propTypes = {
  color: _propTypes2.default.oneOf((0, _values2.default)(OLXPAYBADGE_COLORS)),
  reduced: _propTypes2.default.bool,
  height: _propTypes2.default.number.isRequired,
  // eslint-disable-next-line
  theme: _propTypes2.default.any
};
OlxPayBadge.defaultProps = {
  color: 'colorful',
  reduced: false
};
exports.default = (0, _styledComponents.withTheme)(OlxPayBadge);